module.exports = __webpack_public_path__ + "img/QB-review.ce9f8f0f.png";